import { useCallback } from 'react';
import airfilter from '../assets/airfilter.png';
import airpurifier from '../assets/airpurifier.png';
import facemask from '../assets/facemask.png';
import scarf from '../assets/scarf.png';
import { useGameStore } from '../hooks/useGameStore';

type Props = {
  name: string;
  description: string;
  icon: React.ReactElement;
};

function Player({ name, description, icon }: Props) {
  const [playerName, setPlayerName] = useGameStore(
    useCallback((state) => [state.playerName, state.setPlayerName], [])
  );
  const isActive: boolean = playerName === name;

  return (
    <div className="w-52">
      <button
        onClick={() => setPlayerName(name)}
        className={`rounded-full w-48 h-48 bg-secondary-dark mx-2 mb-4 xl:mb-8 focus:outline-none transition-shadow ${
          isActive ? 'shadow-border' : 'shadow-border-hidden'
        }`}
      >
        {icon}
      </button>

      <h3 className="xl:text-lg text-gray-900 text-center mb-2 xl:mb-4">
        {name}
      </h3>
      <p className="text-xs text-gray-700 text-center">{description}</p>
    </div>
  );
}

export function Player1() {
  return (
    <Player
      name="Luftfilter"
      icon={
        <div className="rounded-full w-full h-full overflow-hidden rounded-tl-none">
          <img
            src={airfilter}
            alt="Luftfilter"
            className="relative top-3 left-4"
          />
        </div>
      }
      description="Vi är stolta över att vara Skandinaviens äldsta tillverkare av luftfilter. Alla våra filter är lokalproducerade och miljösmarta, och renar luften du andas utan att du behöver lyfta ett finger."
    />
  );
}

export function Player2() {
  return (
    <Player
      name="Luftrenare"
      icon={
        <div className="relative rounded-full w-full h-full overflow-hidden rounded-t-none flex justify-center">
          <img
            src={airpurifier}
            alt="Luftrenare"
            className="relative top-10 -left-6/12 transform scale-150"
          />
        </div>
      }
      description="Våra luftrenare från Purafil och Woods eliminerar de tuffaste skadliga virusen och bakterierna, och passar lika bra på sjukhus och äldreboenden som på kontor och i skolor."
    />
  );
}
export function Player3() {
  return (
    <Player
      name="Munskydd"
      icon={
        <div className="rounded-full w-52 h-full overflow-hidden rounded-r-none">
          <img
            src={facemask}
            alt="Munskydd"
            className="w-60 h-auto max-w-none relative right-6 top-2"
          />
        </div>
      }
      description="Munskydd skyddar inte bara dig från smittsamma virus och bakterier – utan också din omgivning. Välj mellan våra CE-märkta engångsmunskydd och våra slitstarka och högklassiga flergångsmunskydd."
    />
  );
}
export function Player4() {
  return (
    <Player
      name="Inte-ont-i-halsduken"
      icon={
        <div className="w-full h-full relative">
          <div className="right-0 rounded-full h-full overflow-hidden rounded-tl-none">
            <img
              src={scarf}
              alt="Halsduk"
              className="relative max-w-none -top-8 right-7 w-64 transform rotate-12"
              // style={{ width: '120%' }}
            />
          </div>
        </div>
      }
      description="Vad är bättre än en mysig, värmande halsduk när det är kallt? En mysig, värmande halsduk fodrad med samma luftfilter som vi säljer till sjukhus för att stoppa spridning av luftburna bakterier. Såklart."
    />
  );
}
